import * as React from "react";
export var LineDescriptionContext = /*#__PURE__*/ React.createContext({
    lineDescription: "",
    lineUrl: {},
    refreshLine: function() {
        return undefined;
    }
});
